'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _viewPromiseModal = require('./../../../promise/promiseList/viewPromise.modal.html');

var _viewPromiseModal2 = _interopRequireDefault(_viewPromiseModal);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactPromisesController = function () {
  function ContactPromisesController(promiseService, $uibModal, $scope, addPromiseService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ContactPromisesController);
    this.promiseService = promiseService;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.addPromiseService = addPromiseService;
  }

  (0, _createClass3.default)(ContactPromisesController, [{
    key: 'complete',
    value: function complete(addAnother) {
      var _this = this;

      var ctrl = this;

      var sure = window.confirm('Are you sure you want to complete this promise');

      if (!sure) {
        return;
      }

      ctrl.promiseService.complete(this.selectedPromise.promiseId, this.tempComments).finally(function () {
        ctrl.selectedPromise.completed = new Date();
        ctrl.selectedPromise.comments = _this.tempComments;
        ctrl.closeModal();
        if (addAnother) {
          ctrl.showAddPromise();
        }
        ctrl.listPromises();
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var ctrl = this;

      if (ctrl.modalInstance) {
        ctrl.modalInstance.close();
      }
    }
  }, {
    key: 'viewPromise',
    value: function viewPromise(promise) {
      this.errMsg = '';
      this.tempComments = '';
      this.selectedPromise = promise;
      this.modalInstance = this.$uibModal.open({
        template: _viewPromiseModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'completePromise',
    value: function completePromise(addAnother) {
      if (!this.tempComments) {
        this.errMsg = "Please enter some comments first";
        return;
      }

      this.complete(addAnother);
    }
  }, {
    key: 'showAddPromise',
    value: function showAddPromise() {
      this.addPromiseService.showAddPromise(this.addPromise.bind(this), false, '', { contactId: this.contact.contactId, contactName: this.contact.contactName }, true);
    }
  }, {
    key: 'addPromise',
    value: function addPromise(promise) {
      this.promises.push(promise);
      this.promises = (0, _lodash.reverse)((0, _lodash.sortBy)(this.promises, 'dueDate'));
    }
  }]);
  return ContactPromisesController;
}();

exports.default = ContactPromisesController;


// WEBPACK FOOTER //
// ./client/app/components/contact/contactView/contactPromises/contactPromises.controller.js